// SKZEnvironment.types.ts

/**
 * Enum representing all known Skillz environment names.
 * Use this when referencing environments in your logic (e.g., Environment.STAGING).
 */
export enum SKZEnvironment {
  QA = 'qa',
  QA_SANDBOX = 'qa-sandbox',
  STAGING = 'staging',
  STAGING_SANDBOX = 'staging-sandbox',
  PRODUCTION = 'production',
  PRODUCTION_SANDBOX = 'production-sandbox',
}

/**
 * Type representing all valid Skillz environment string values.
 * Use this for typing variables, function return types, and validation schemas.
 */
export type SKZEnvironmentValue = `${SKZEnvironment}`;
